import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../utils/axiosAuth";

export const fetchInventoryProducts = createAsyncThunk(
  "inventoryProducts/fetch",
  async (_, thunkAPI) => {
    try {
      const response = await api.get(`/api/get_active_products`);
      return { rows: response.data || [] };
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

const inventoryProductsSlice = createSlice({
  name: "inventoryProducts",
  initialState: { rows: [], status: "idle", error: null },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchInventoryProducts.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchInventoryProducts.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.rows = action.payload.rows;
        console.log("📦 جميع الأصناف المحمّلة:", action.payload.rows);
      })
      .addCase(fetchInventoryProducts.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload || "حدث خطأ غير متوقع";
      });
  },
});

export default inventoryProductsSlice.reducer;

export const selectInventoryProductsRows = (state) =>
  state.inventoryProducts.rows;
export const selectInventoryProductsStatus = (state) =>
  state.inventoryProducts.status;
export const selectInventoryProductsError = (state) =>
  state.inventoryProducts.error;
